import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

void i18n.use(initReactI18next).init({
  lng: 'zh-CN',
  fallbackLng: 'zh-CN',
  interpolation: { escapeValue: false },
  resources: {
    'zh-CN': {
      translation: {
        ui: {
          visualizerMode: '歌词模式',
          backgroundMode: '背景模式',
          waitingForMusic: ' ',
          back: '返回',
          backToHome: '返回主页',
          play: '播放',
          pause: '暂停',
          close: '关闭',
          nowPlaying: '正在播放',
          animationMode: '歌词样式',
          animationIntensity: '动画强度',
          moreSettings: '更多设置',
          settingsGuideTitle: '动画设置和录制在这里',
          settingsGuideBody: '切换歌词样式与主题，也可以录制 PV',
          settingsGuideAction: '知道了',
          themeMode: '主题',
          themeLight: '亮色',
          themeDark: '暗色',
          browserFullscreen: '全屏',
          exitFullscreen: '退出全屏',
          exitLyricStage: '退出动画模式',
          playlist: '歌曲',
          stage: '动画',
          emptyPlaylist: '暂无歌曲',
          previousTrack: '上一首',
          nextTrack: '下一首',
          recordPv: '录制 PV',
          recording: '录制中',
          cancelRecord: '取消',
          recordCountdown: '即将开始 {{n}}',
          recordNeedTab: '请选择当前标签页以开始录制',
          recordUnsupported: '当前浏览器不支持 MP4，请使用更新的 Chrome / Edge / Safari',
          visualizerClassic: '流光',
          visualizerCadenze: '心象',
          visualizerCadenza: '心象',
          visualizerPartita: '云阶',
          visualizerFume: '浮名',
          visualizerCappella: '群唱',
          visualizerTilt: '倾诉',
          visualizerCladdagh: '回环',
          visualizerMonet: '莫奈',
          visualizerDiorama: '镜台',
          visualizerPendolo: '时计',
          visualizerSonnet: '商籁',
          visualizerTempera: '凝彩',
          visualizerStill: '静止',
          backgroundCommon: '通用',
          backgroundLatent: '隐现',
          backgroundMonet: '莫奈',
          backgroundNomand: '漫游',
          backgroundSora: '空',
          backgroundUrl: '嵌入',
        },
        panel: {
          controls: '控制',
        },
        options: {
          visualizerBackgroundMode: '背景类型',
          visualizerBackgroundModeCommon: '通用',
          visualizerBackgroundModeMonet: '莫奈',
          visualizerBackgroundModeNomand: '漫游',
          visualizerBackgroundModeLatent: '隐现',
          visualizerBackgroundModeUrl: '嵌入',
          visualizerBackgroundModeSora: '空',
          latentDisplayMode: '显示图层',
          latentDisplayDithering: '像素',
          latentDisplayMesh: '流体',
          latentDisplayBoth: '混合',
          nomandBackgroundOverlay: '叠加层',
          monetBackgroundLayout: '布局模式',
          monetLayoutFullOverlay: '全屏叠色',
          monetLayoutHalfPane: '半屏渐变',
        },
        animation: {
          calm: '平静',
          normal: '标准',
          chaotic: '混乱',
        },
        theme: {
          addCoverColor: '添加封面色彩',
          useDefaultColor: '使用默认色彩',
        },
      },
    },
  },
})

export default i18n
